// extracted by mini-css-extract-plugin
module.exports = {"root":"LabeledBox_root__3cbBf","label":"LabeledBox_label__2IpgI"};